import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import Box from "@mui/material/Box";
import Typography from "@mui/material/Typography";
import React from "react";
const Surtitle = (props) => {
    const { title, contrast = false, component = "p" } = props;
    return (_jsxs(Box, { sx: {
            width: "fit-content",
            display: "flex",
            alignItems: "center",
            gap: "8px",
        }, children: [_jsx(Box, { sx: {
                    width: "12px",
                    height: "2px",
                    flexShrink: 0,
                    bgcolor: contrast ? "primary.contrastText" : "text.primary",
                } }), _jsx(Typography, { variant: "subtitle2", component: component, sx: {
                    color: contrast ? "primary.contrastText" : "text.secondary",
                    fontWeight: 400,
                    fontSize: { xs: "12px", md: "14px" },
                    lineHeight: { xs: "130%", md: "150%" },
                    textTransform: "uppercase",
                    letterSpacing: "0.06em",
                    opacity: contrast ? 0.8 : 1,
                }, children: title })] }));
};
export default Surtitle;
